import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  glow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  glow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-night-950';
  const variants = {
    primary: 'bg-gold-500 hover:bg-gold-400 text-night-950 font-bold',
    secondary: 'bg-night-800 hover:bg-night-700 text-gold-500 border border-gold-500/30',
    outline: 'bg-transparent border border-gold-500 text-gold-500 hover:bg-gold-500/10'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const glowClass = glow ? 'animate-glow-pulse shadow-[0_0_15px_rgba(212,168,83,0.3)]' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${glowClass} ${className}`} {...props} data-id="element-190">
      {children}
    </motion.button>;
}